import { useContext, useEffect, useState } from 'react'
import { getRequest, putRequest } from '../../../../services/base'
import { useNavigate, useParams } from 'react-router-dom'
import { NavContext } from '../../../../context/global_context'
import TextArea from '../../../common/TextArea'
import DtcsHeader from '../DtcsHeader'
import { Card, Flex, Form, Row, Space, Typography } from 'antd'
import CloneMappings from './CloneMappings'
import Button from '../../../common/Button'
import { useIntl } from 'react-intl'

const DtcCloneComponent = () => {
  const [value, dispatch] = useContext(NavContext)
  let { dtc_id, vehicle } = useParams()
  const navigate = useNavigate()
  const intl = useIntl()
  const [form] = Form.useForm()
  const [payload, setPayload] = useState({
    create_dtc_circuits: false,
    clone_with_existing_mapping: false,
    target_dtcs: [],
    active: false,
    destination_only: false,
    short_description: '',
    description: '',
    description_2: '',
    ecu: '',
    name: '',
  })

  const saveDtcs = async () => {
    dispatch({
      type: 'loader',
      data: {
        caption: intl.formatMessage({ id: 'dtcs.clone.saving' }),
        showLoader: true,
      },
      notification: {},
    })
    let res = await putRequest(`/api/dtcs/update_dtcs/${dtc_id}/`, payload)
    dispatch({
      type: 'notification',
      data: {
        notification_type: 'success',
        msg: intl.formatMessage({ id: 'dtcs.clone.cloneSuccess' }, { name: value?.dtc_details[0].name }),
      },
    })
  }

  useEffect(() => {
    getDtcsList()
  }, [])

  const getDtcsList = async () => {
    dispatch({
      type: 'loader',
      data: {
        caption: intl.formatMessage({ id: 'dtcs.clone.fetchingData' }),
        showLoader: true,
      },
      notification: {},
    })

    let dtcs_res = await getRequest(`/api/dtcs/${dtc_id}/?vehicle=${vehicle}`)

    setPayload({
      ...payload,
      active: dtcs_res.active,
      destination_only: dtcs_res.destination_only,
      description_2: dtcs_res.description_2,
      description: dtcs_res.description,
      short_description: dtcs_res.short_description,
      ecu: dtcs_res.ecu,
      name: dtcs_res.name,
    })

    dispatch({
      type: 'header',
      data: {
        header: intl.formatMessage({ id: 'layout.adminTools' }),
        sub_header: `Vehicle List / ${vehicle} / DTCs / Tracer Authoring Mappings / DTC Clone`,
        id: '',
        show_back_btn: true,
        dtc_details: [dtcs_res],
        vehicle: vehicle,
        back_btn_url: `/vehicles/${vehicle}/dtcs/listing`,
      },
    })
  }

  return (
    <div className="page dtc-clone">
      <Row className="title">
        <Flex vertical gap={16} style={{ width: '100%' }}>
          {value?.dtc_details?.length > 0 && (
            <DtcsHeader dtcs={value?.dtc_details} vehicleSid={value?.vehicle} />
          )}
          <Typography.Title level={5}>
            {intl.formatMessage({ id: 'dtcs.clone.title'}, {ecu: payload.ecu, name: payload.name })}
          </Typography.Title>
        </Flex>
      </Row>
      <Row className="body">
        <Form
          id="dtc-clone-form"
          name="dtc-clone-form"
          form={form}
          layout="vertical"
          onFinish={() => saveDtcs()}
        >
          <Card title="" variant="outlined">
            <Flex gap={16} vertical>
              <CloneMappings
                formRef={form}
                payload={payload}
                setPayload={setPayload}
              />
            </Flex>
          </Card>

          <Space size="middle">
            <Button htmlType="submit" type="primary" className="submit-button" testId="dtc-clone-save">
              {intl.formatMessage({ id: 'dtcs.clone.cloneMapping' })}
            </Button>

            <Button
              className="cancel-button"
              onClick={(e) => navigate(`/vehicles/${vehicle}/dtcs/listing`)}
            >
              {intl.formatMessage({ id: 'forms.cancel' })}
            </Button>
          </Space>
          
        </Form>
      </Row>
    </div>
  )
}

export default DtcCloneComponent
